import { api, handleSubscriptionRedirect } from "../../api/api"
import { IUserProfile } from "../../redux/UserProfileList/userProfile.types"



import { AxiosError } from "axios";

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  code?: string;
  data: T;
}

export const fetchAuthUserProfileAsync = async (
  user_uuid: string
): Promise<IUserProfile> => {
  try {
    const response = await api.get<ApiResponse<IUserProfile[]>>(
      "/user/get-user",
      {
        params: {
          status: "ACTIVE",
          user_uuid
        }
      }
    );
    const { data } = response.data;
    return data[0];
  } catch (err) {
    console.log("fetchAuthUserProfileAsync ===>", err)
    const error = err as AxiosError<any>;
    const status = error.response?.status;
    const errorData = error.response?.data;
    const code = errorData?.code;
    const message = errorData?.message;
    if (status === 403) {
      handleSubscriptionRedirect(code, message)
    }
    throw new Error(
      error.response?.data?.message || error.message || "API request failed"
    );
  }
};

// export const fetchAuthUserProfileAsync = async (
//   user_uuid: string
// ): Promise<IUserProfile> => {

//   const mockResponse = {
//     success: false,
//     message: "Subscribe to access this feature!",
//     code: "1001",
//     data: []
//   };

//   if (!mockResponse.success) {
//     const error: any = new Error(
//       mockResponse.message || "Failed to fetch user profile"
//     );
//     error.code = mockResponse.code;
//     throw error;
//   }

//   return mockResponse.data[0];
// };